import { render, staticRenderFns } from "./RadioAlarmList.vue?vue&type=template&id=66ff23b6&scoped=true&"
import script from "./RadioAlarmList.vue?vue&type=script&lang=js&"
export * from "./RadioAlarmList.vue?vue&type=script&lang=js&"
import style0 from "./RadioAlarmList.vue?vue&type=style&index=0&id=66ff23b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff23b6",
  null
  
)

export default component.exports